module.exports = __webpack_public_path__ + "static/media/30OIOS11.44b07655.jpg";